<div *ngIf="isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>

<!-- HEADER / NAV (shared for PDF + HTML) -->
<div [hidden]="!isPrimary" id="mention_table">
	<div class="relative tyalls-table-name flex justify-content-between pr-3">
        <div
                (click)="onBackClicked()"
                class="absolute back-tag-position cursor-pointer flex gap-2"
        >
            <div class="text-white schedule-tag-comments">
                <div class="flex text-white font-bold mr-2">&lt; Back</div>
            </div>
        </div>

        <!-- Due date -->
        <div class="absolute date-tag-position flex gap-2">
            <div class="text-white schedule-tag-comments">
                <div class="flex">
                    <span class="dark-purple-text font-bold mr-2">Due: </span>
                    <span data-cy="due-date">
						{{ currentTask?.dueDate | DateLocalFormat: false }}
					</span>
                </div>
            </div>
        </div>
        <!-- Header main row -->
        <div class="task-report-header-row">
            <!-- LEFT -->
            <div class="task-report-header-left">
                <h6
                        (click)="onPreviousClicked()"
                        [hidden]="!currentTask?.prevTask"
                        class="tyalls-table-heading task-scroll-text cursor-pointer ml-1"
                >
                    &lt;&lt; <span *ngIf="viewerPanelInFocus">Previous</span>
                </h6>
            </div>

            <!-- CENTER -->
            <div class="task-report-header-center">
                <h6
                        *ngIf="viewerPanelInFocus"
                        class="tyalls-table-heading text-sm md:text-base"
                        title="{{ currentTask?.name?.trim() }}"
                >
                    <span class="opacity-60 hidden md:inline mr-1">Task name:</span>
                    {{ currentTask?.name?.trim() }}
                    <span *ngIf="currentTask?.type === WorkflowType.Form">
        &nbsp;-&nbsp;{{ currentTask?.processId }}
      </span>
                </h6>
            </div>

            <!-- RIGHT -->
            <div class="task-report-header-right">
                <div *ngIf="canShowViewerToggle" class="viewer-toggle">
                    <button
                            type="button"
                            class="p-button p-button-sm"
                            [disabled]="activeViewer === 'pdf'"
                            (click)="setActiveViewer('pdf')"
                    >
                        PDF
                    </button>
                    <button
                            type="button"
                            class="p-button p-button-sm"
                            [disabled]="activeViewer === 'html'"
                            (click)="setActiveViewer('html')"
                    >
                        HTML
                    </button>
                </div>

                <h6
                        (click)="onNextClicked()"
                        [hidden]="!currentTask?.nextTask"
                        class="tyalls-table-heading task-scroll-text cursor-pointer text-right"
                >
                    <span *ngIf="viewerPanelInFocus">Next</span> &gt;
                </h6>
            </div>
        </div>
	</div>
</div>

<!-- Spacer (viewer-aware, not PDF-aware) -->
<div *ngIf="shouldShowTopSpacer" [class]="topSpacerClass"></div>

<!-- REVIEW (non-form tasks) -->
<div *ngIf="canReviewNonFormTask" [class]="topSpacerClass" class="flex justify-content-end pr-2 py-2">
	<button
		data-cy="review-button"
		(click)="onReviewClicked()"
		[disabled]="isSubmitDisabled"
		class="p-button-raised w-fit"
		label="Review"
		pButton
		pRipple
		type="button"
	></button>
</div>

<!-- FORM ACTIONS (phobos forms) -->
<div *ngIf="canReviewFormTask" [class]="formActionsContainerClass" class="choose-button-padding">
	<div class="mb-2">
		<app-group-drop-down
			(groupChange)="onGroupChange($event)"
			label="Please Select a Group to Assign the Form to"
		></app-group-drop-down>
	</div>

	<div class="mb-2">
		<button
			(click)="onAssignClicked($event)"
			[disabled]="isSubmitDisabled"
			class="p-button-raised"
			label="Review & Assign"
			pButton
			pRipple
			type="button"
		></button>
	</div>

	<div class="mb-2">
		<button
			(click)="onCompleteClicked($event)"
			[disabled]="isSubmitDisabled"
			class="p-button-raised"
			label="Review & Complete Task"
			pButton
			pRipple
			type="button"
		></button>
	</div>
</div>

<!-- RESEND / REVERT (completed phobos forms) -->
<div *ngIf="canShowResendAndRevertRow" class="flex justify-content-end choose-button-padding">
	<div class="flex gap-3 w-full justify-content-end">
		<button
			(click)="onReopenClicked($event)"
			*ngIf="canShowRevertButton"
			[disabled]="isSubmitDisabled"
			class="p-button-raised p-mr-2 p-mb-2 max-w-fit"
			label="Revert Task"
			pButton
			pRipple
			type="button"
		></button>

		<button
			(click)="onResendClicked($event)"
			[disabled]="isSubmitDisabled"
			class="p-button-raised max-w-fit"
			label="Resend Completion Email"
			pButton
			pRipple
			type="button"
		></button>
	</div>
</div>

<!-- VIEWER SLOT: Parent renders either PDF viewer OR HTML viewer here -->
<ng-content></ng-content>
